import type { CalculationResult } from '../types';

/**
 * The calculation trail, styled as a ruled notebook page.
 *
 * Every step shows the symbolic form, the substituted form, and the result, so
 * a reader can follow the arithmetic without trusting the code.
 */
export function DerivationPanel({ result }: { result: CalculationResult | null }) {
  if (!result) {
    return <p className="empty-state">The derivation appears once a valid scenario is entered.</p>;
  }

  return (
    <div className="derivation">
      <ol className="derivation-list">
        {result.derivation.map((step, index) => (
          <li key={`${step.label}-${index}`} className="derivation-step">
            <p className="derivation-label">{step.label}</p>
            {step.expression && <pre className="derivation-line derivation-symbolic">{step.expression}</pre>}
            {step.substituted && <pre className="derivation-line derivation-substituted">{step.substituted}</pre>}
            {step.result && <pre className="derivation-line derivation-result">{step.result}</pre>}
            {step.note && <p className="derivation-note">{step.note}</p>}
          </li>
        ))}
      </ol>
      <p className="derivation-footer">
        No intermediate value is rounded. Rounding happens only where it is labelled as such, and the unrounded figure
        stays on screen next to it.
      </p>
    </div>
  );
}
